<template>
  <v-app>
    <v-main>
      <div class="my-10 bg-secondary ma-auto pa-10">
        <div
          class="text-h4 text-center my-5"
          style="font-family: nitalago-ruika, sans-serif;"
        >
          「宵祓い探偵 ミアズマブレイカー」<br />実況・動画配信のガイドライン
        </div>
        <v-img
          src="http://d-mebius.com/miasmabreaker/img/ss_st.jpg"
          width="800"
          height="450"
          class="ma-auto"
          cover
        ></v-img>

        <p
          style="text-align: center; line-height: 1.5em;"
          class="text-h6 pa-3 w-75 ma-auto"
        >
          下記に実況・動画配信に関してのガイドラインを制定させて頂きます。
        </p>
        <div class="d_area">
          <p>
            ◆こちらの作品は全編実況動画投稿・配信を許可します。
          </p>
          <p>
            ◆実況・動画配信をする際は、1.0.2以上のバージョンにアップデートをしてください。
          </p>
          <hr />
          <p>
            ◆キャプション等に下記の権利表記の記載をしてください。<br />
            <span
              style="
                text-decoration: underline;
                text-decoration-color: #fff000;
              "
              >©mebius.</span
            >
          </p>
        </div>
        <p
          style="text-align: center; line-height: 1.5em;"
          class="text-h6 pa-3 w-75 ma-auto"
        >
          実況配信において、常識の範囲内であれば基本的に何をやって頂いても問題ございませんが、<br />ゲームや開発・販売会社、クリエイターの品位・信用を損ねるものはご遠慮ください。
        </p>

        <p
          style="text-align: center; line-height: 1.5em;"
          class="text-h6 pa-3 w-75 ma-auto"
        >
          動画や配信で他者を誹謗中傷している場合や公序良俗に反していると判断した場合、<br />
          動画の削除や配信中止のお願いをすることがございます。
        </p>
      </div>

      <!-- footerコンポーネントの使用 -->
    </v-main>
  </v-app>
</template>

<script>
  // import AppFooter from "./AppFooter.vue";
  export default {
    components: {
      //  AppFooter,
    },
  };
</script>

<style scoped>
  .d_area {
    border: #fff solid 1px;
    padding: 2em;
    margin: 2em auto !important;
    line-height: 2.5em;
    width: 80%;
  }
  .d_area p {
    margin: 1em auto;
  }
</style>
